import React, { useEffect } from 'react';
import { Header } from '@assets/components/Header/Header';
import { Footer } from '@assets/components/Footer/Footer';

import './GlobalLayout.scss';

type GlobalLayoutProps = {
  showHeaderNav?: boolean;
  children?: React.ReactNode;
};

export default function GlobalLayout({
  showHeaderNav,
  children
}: GlobalLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header showNav={showHeaderNav} />
      <main className="betterMood__container">{children}</main>
      <Footer theme="dark" />
    </>
  );
}
